(function () {
  'use strict';
  const serviceId = 'repo.designers';
  angular
    .module('app')
    .service(serviceId,
      ['data', 'common',
        function (dataContext, common) {

          const context = dataContext.context({
            controller: 'charts'
          });

          const $q = common.$q;

          function search(req) {
            const def = $q.defer();

            context.get('designers')
              .then(function (response) {
                def.resolve(response.result || response.data);
              }).catch(function () {
              const res = {};
              def.resolve(res);
            });

            return def.promise;
          }

          this.search = search;
        }
      ]);
}());
